import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array } from "../../../shared/src/codecs/types/array";
import { form } from "../../../shared/src/codecs/types/form";
import { required } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { uuid } from "../../../shared/src/codecs/types/uuid";

export const PublicQuoteInstructLinkForm = form(
    required({
        case_ids: array(uuid()),
    }),
    required({
        sent_to: string(),
    }),
);
export type TPublicQuoteInstructLinkFormCodec = typeof PublicQuoteInstructLinkForm;
export type TPublicQuoteInstructLinkForm = TTypeOfCodec<TPublicQuoteInstructLinkFormCodec>;
